module.exports = __webpack_public_path__ + "static/media/Plumber.cf13cc0c.jpg";